var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadeadoCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 3.33337C17.6811 3.33337 15.1376 4.38694 13.2622 6.26231C11.3869 8.13767 10.3333 10.6812 10.3333 13.3334V17.0834H13.6666V13.3334C13.6666 11.5653 14.369 9.86957 15.6193 8.61933C16.8695 7.36909 18.5652 6.66671 20.3333 6.66671C22.1014 6.66671 23.7971 7.36909 25.0474 8.61933C26.2976 9.86957 27 11.5653 27 13.3334V17.0834H30.3333V13.3334C30.3333 10.6812 29.2797 8.13767 27.4044 6.26231C25.529 4.38694 22.9855 3.33337 20.3333 3.33337Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 36.6666H8.66665C8.22462 36.6666 7.8007 36.491 7.48814 36.1785C7.17558 35.8659 6.99998 35.442 6.99998 35V18.3333C6.99998 17.8913 7.17558 17.4673 7.48814 17.1548C7.8007 16.8422 8.22462 16.6666 8.66665 16.6666H32C32.442 16.6666 32.8659 16.8422 33.1785 17.1548C33.4911 17.4673 33.6667 17.8913 33.6667 18.3333V35C33.6667 35.442 33.4911 35.8659 33.1785 36.1785C32.8659 36.491 32.442 36.6666 32 36.6666Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6666 18.3333V35C33.6667 35.2188 33.6236 35.4356 33.5399 35.6378C33.4562 35.8401 33.3334 36.0238 33.1786 36.1786C33.0239 36.3334 32.8401 36.4561 32.6379 36.5399C32.4356 36.6236 32.2189 36.6667 32 36.6666H9.49998L29.5 16.6666H32C32.2189 16.6666 32.4356 16.7096 32.6379 16.7934C32.8401 16.8771 33.0239 16.9999 33.1786 17.1546C33.3334 17.3094 33.4562 17.4932 33.5399 17.6954C33.6236 17.8977 33.6667 18.1144 33.6666 18.3333Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 17.9166H6.99998C6.99998 17.5851 7.13168 17.2672 7.3661 17.0327C7.60052 16.7983 7.91846 16.6666 8.24998 16.6666H32.4167C32.7482 16.6666 33.0661 16.7983 33.3005 17.0327C33.535 17.2672 33.6667 17.5851 33.6667 17.9166Z",
    fill: "#CD992B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 35.4166H33.6667C33.6667 35.7481 33.535 36.0661 33.3005 36.3005C33.0661 36.5349 32.7482 36.6666 32.4167 36.6666H8.24998C7.91846 36.6666 7.60052 36.5349 7.3661 36.3005C7.13168 36.0661 6.99998 35.7481 6.99998 35.4166Z",
    fill: "#CD992B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 25.0001C22.0013 24.7072 21.9255 24.4191 21.7801 24.1648C21.6347 23.9106 21.4249 23.6991 21.1717 23.5518C20.9186 23.4045 20.6311 23.3264 20.3382 23.3256C20.0453 23.3247 19.7574 23.401 19.5034 23.5469C19.2494 23.6927 19.0383 23.903 18.8914 24.1563C18.7445 24.4097 18.667 24.6974 18.6667 24.9903C18.6663 25.2831 18.7432 25.571 18.8895 25.8247C19.0357 26.0784 19.2463 26.2891 19.5 26.4356V29.1667C19.5 29.3877 19.5878 29.5997 19.744 29.756C19.9003 29.9123 20.1123 30.0001 20.3333 30.0001C20.5543 30.0001 20.7663 29.9123 20.9226 29.756C21.0788 29.5997 21.1666 29.3877 21.1666 29.1667V26.4356C21.4194 26.2906 21.6294 26.0815 21.7757 25.8295C21.922 25.5775 21.9994 25.2914 22 25.0001Z",
    fill: "#0083CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadeadoCor);
export default __webpack_public_path__ + "static/media/cadeado-cor.70f30a975aa9f45f1c09679b32a678e6.svg";
export { ForwardRef as ReactComponent };